import Api from '../http.service';
/**
 * search Flight (from all gateways)
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.itineraries
 * @param {number} payload.data.child
 * @param {number} payload.data.infant
 * @param {number} payload.data.citizen
 * @param {number} payload.data.student
 * @param {String} payload.data.cabin
 */
export const search = (payload) =>
  Api.POST({ data: payload.data, url: `gateway/search` });

/**
 * search calendar flight
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.itineraries
 * @param {number} payload.data.child
 * @param {number} payload.data.infant
 * @param {number} payload.data.citizen
 * @param {number} payload.data.student
 * @param {String} payload.data.cabin
 */
export const searchCalendar = (payload) =>
  Api.POST({ data: payload.data, url: `gateway/search_calendar` });

/**
 * Flight cancel Rules
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {Object} payload.data.itineraryFlights
 * @param {String} payload.data.sequenceNumber
 * @param {String} payload.data.combinationId
 * @param {Object} payload.data.gatewayData
 * @param {String} payload.data.providerType
 */

export const cancelRules = (payload) =>
  Api.POST({ data: { ...payload.data }, url: `gateway/rules` });

/**
 * book ticket from gateway
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.paymentType
 * @param {String} payload.data.token
 */

// Book Flight
export const bookFlight = (payload) =>
  Api.POST({
    data: {
      ...payload.data,
      redirectUrl: `${window.location.origin}/#/booking/payment-result`,
    },
    url: `gateway/book`,
  });

// get getGatewayInfoByPNR
export const getGatewayList = () =>
  Api.GET({ url: 'gateway/import_pnr_enabled' });

/**
 * get importPNR
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.gatewayName
 * @param {String} payload.pnr
 */
export const importPNR = (payload) =>
  Api.POST({
    url: `gateway/import_pnr/${payload.gatewayName}/${payload.pnr}`,
    data: payload.data,
  });

/**
 * get issues ticket
 * @param {String} bookingFlightId
 */
export const getIssueTicket = (bookingFlightId) =>
  Api.GET({ url: `gateway/issue_ticket/${bookingFlightId}` });

/**
 * ping connection for gateway amadeus
 */
export const pingAmadeusGateway = () =>
  Api.GET({ url: `gateway/amadeus/ping` });
/**
 * get gateWay
 */
export const gateway = () => Api.GET({ url: 'gateway' });

/**
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 */
export const getGateway = (payload) =>
  Api.GET({
    url: `gateway/all?page=${payload.pageNumber}&size=${payload.itemPerPage}&where=${payload.data.filter}&sort=name&order=asc`,
  });

/**
 *
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {object} payload.data
 * @param {string} payload.data.internalCode
 * @param {string} payload.data.phrase
 */
export const getByGatewayCode = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `gateway_gds/gatewayAirlines/${data.internalCode}?page=${
      pageNumber - 1
    }&size=${itemPerPage}&where={"phrase":"${data.phrase}"}`,
  });

/**
 * @param {Object} payload
 * @param {Object} payload.data
 * @param {String} payload.data.internalCode
 * @param {String} payload.data.from
 * @param {String} payload.data.to
 * @param {String} payload.data.weekDays
 * @param {String} payload.data.airlineCode
 */
export const insert = ({ data }) => Api.POST({ url: `gateway_route`, data });

/**
 * @param {Object} payload
 * @param {Number} payload.pageNumber
 * @param {Number} payload.itemPerPage
 * @param {Object} payload.data
 * @param {String} payload.data.filter
 * @param {Object} payload.data.sort
 * @param {String} payload.data.sort.key
 * @param {String} payload.data.sort.value
 */
export const getByPaging = ({ pageNumber, itemPerPage, data }) =>
  Api.GET({
    url: `gateway_route/all?page=${pageNumber - 1}&size=${itemPerPage}&where=${
      data.filter
    }&sort=${data.sort.key}&order=${data.sort.value}`,
  });
